module.exports = __webpack_public_path__ + "0b6286282871ae8ffc7ad522938eda08.pdf";